export default "__VITE_ASSET__BOQP24aE__"